import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { AssetSelectedTypeMap } from '../../../../../../../../../store/product/types';

import { DirectTreasuryItemSelectedDesktop } from './desktop';
import { DirectTreasuryItemSelectedMobile } from './mobile';
import { DirectTreasuryItemSelectedTablet } from './tablet';

export namespace DirectTreasuryItemSelectedTypes {
  export interface Props {
    offer: AssetSelectedTypeMap['directTreasury'];
    onUpdate: (offerUpdated: AssetSelectedTypeMap['directTreasury']) => void;
    hideLateralBar?: boolean;
  }
}

export const DirectTreasuryItemSelected: React.FC<DirectTreasuryItemSelectedTypes.Props> = (
  props
) => {
  const directTreasurySelectedItem = useBreakpointValue({
    base: <DirectTreasuryItemSelectedMobile {...props} />,
    sm: <DirectTreasuryItemSelectedTablet {...props} />,
    lg: <DirectTreasuryItemSelectedDesktop {...props} />,
  });

  return directTreasurySelectedItem;
};
